<template>
  <div class="containes">
    <div class="container_c">
      <div>
        创新，创造，只为生活更美好
      </div>
      Innovation,creation,only for better life

    </div>
    <a
      class="footer"
      href="https://beian.miit.gov.cn/"
    >Copyright {{ curYear }} All Rights Reserved. 佛燃科技智能阴保管理系统 粤ICP备2022089787号-4</a>
    <div class="main">
      <div class="main_top">
        <img
          src="~@/assets/logo.png"
          alt=""
        >
      </div>
      <div class="main_t_h">
        欢迎来到佛燃科技智能阴保管理系统
      </div>
      <a-form-model
        id="formLogin"
        ref="form"
        class="user-layout-login"
        :model="form"
        :rules="rules"
      >
        <a-alert
          v-if="isLoginError"
          type="error"
          showIcon
          style="margin-bottom: 24px;"
          :message="loginErrorInfo"
          closable
          :after-close="handleCloseLoginError"
        />
        <a-form-model-item prop="accountNo">
          <div class="account">
            <a-input
              v-model="form.accountNo"
              size="large"
              placeholder="请输入账号"
            >
              <a-icon
                slot="prefix"
                type="mobile"
                :style="{ color: '#1c1f27', fontSize: '22px' }"
              />
            </a-input>
            <!-- <img
            src="~@/assets/images/shou.png"
            alt=""
          > -->
          </div>


        </a-form-model-item>
        <a-form-model-item prop="password">
          <a-input-password
            v-model="form.password"
            size="large"
            placeholder="请输入密码"
          >
            <a-icon
              slot="prefix"
              type="lock"
              :style="{ color: '#1c1f27', fontSize: '22px' }"
            />
          </a-input-password>
        </a-form-model-item>
        <a-row
          :gutter="16"
          v-if="captchaEnabled"
        >
          <a-col
            class="gutter-row"
            :span="16"
          >
            <a-form-model-item prop="code">
              <a-input
                v-model="form.code"
                size="large"
                type="text"
                autocomplete="off"
                placeholder="验证码"
              >
                <a-icon
                  slot="prefix"
                  type="security-scan"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col
            class="gutter-row"
            :span="8"
          >
            <img
              class="getCaptcha"
              :src="codeUrl"
              @click="getCode"
            >
          </a-col>
        </a-row>
        <!-- <a-form-model-item prop="rememberMe">
        <a-checkbox
          :checked="form.rememberMe"
          @change="rememberMe"
        >记住密码</a-checkbox>
      </a-form-model-item> -->
        <a-form-item style="margin-top:24px">
          <!-- <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="logining"
          :disabled="logining"
          @click="handleSubmit"
        >确定</a-button> -->
          <div
            class="foot_b"
            @click="handleSubmit"
          >
            登录
          </div>
        </a-form-item>
        <div class="user-login-other">
          <!--
          ruoyi后台不支持获取是否开启账户.
          故此处不做隐藏处理. 在ruoyi原前端中是在注册页面定义一个属性手动修改处理.
          <router-link class="register" :to="{ name: 'register' }">注册账户</router-link>
        -->

        </div>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getCodeImg } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import storage from 'store'

export default {
  components: {
  },
  data () {
    return {
      codeUrl: '',
      isLoginError: false,
      loginErrorInfo: '',
      curYear: new Date().getFullYear(),
      form: {
        accountNo: '',
        password: '',
        code: undefined,
        uuid: '',
        rememberMe: false
      },
      rules: {
        accountNo: [{ required: true, message: '请输入帐户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      logining: false,
      captchaEnabled: false,
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created () {
    this.getStorage()
    if (this.captchaEnabled) {
      this.getCode()
    }
  },
  methods: {
    getCode () {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.img
          this.form.uuid = res.uuid
        }
      })
    },
    getStorage () {
      const accountNo = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (accountNo) {
        this.form = {
          accountNo: accountNo,
          password: password,
          rememberMe: rememberMe
        }
      }
    },
    rememberMe (e) {
      this.form.rememberMe = e.target.checked
    },
    ...mapActions(['Login', 'Logout']),
    handleSubmit () {
      this.logining = true
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.rememberMe) {
            storage.set(LOGIN_USERNAME, this.form.accountNo)
            storage.set(LOGIN_PASSWORD, this.form.password)
            storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          } else {
            storage.remove(LOGIN_USERNAME)
            storage.remove(LOGIN_PASSWORD)
            storage.remove(LOGIN_REMEMBERME)
          }
          this.$store.dispatch('Login', this.form).then((res) => {
            console.log('999', res)
            this.$router.push({ path: 'home' }).catch(() => {
              // that.$store.commit('IS_HOME', true)
            })
            // this.$router.push({ path: this.redirect || '/' }).catch(() => { })
          }).catch((err) => {
            console.log('err', err)
            this.loading = false
            setTimeout(() => {
              this.logining = false
            }, 1000)
            if (this.captchaEnabled) {
              this.getCode()
            }
          })
          // this.Login(this.form)
          //   .then((res) => this.loginSuccess(res))
          //   .catch(err => this.requestFailed(err))
          //   .finally(() => {
          //     this.logining = false
          //   })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    loginSuccess (res) {
      // this.$router.push({ path: '/' })
      this.$router.push({ path: '/user/home' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      this.handleCloseLoginError()
    },
    requestFailed (err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
      if (this.captchaEnabled) {
        this.getCode()
      }
    },
    handleCloseLoginError () {
      this.isLoginError = false
      this.loginErrorInfo = ''
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 473px;
  height: 458px;
  background: #fff;
  position: absolute;
  top: 270px;
  right: 194px;
  border: 6px;
  padding: 50px 48px 50px 49px;

  .main_top {
    margin-bottom: 25px;
    text-align: center;

    img {
      width: 64px;
      height: 64px;
      margin-right: 13px;
    }
  }

  .main_t_h {
    font-size: 22px;
    color: #333;
    margin-bottom: 41px;
    text-align: center;
  }

  .ant-input {
    background: #F7F7F7;
    height: 52px;
    padding-left: 153px;

  }

  /deep/ .ant-input-affix-wrapper .ant-input:not(:first-child) {
    padding-left: 53px;
    // color: #999;
    font-size: 16px;
  }

  /deep/ .ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
    color: #707070;
    font-size: 18px;
  }
}

.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .register {
      float: right;
    }
  }

  .foot_b {
    width: 376px;
    height: 48px;
    background: #26AC38;
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #fff;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
  }
}

.containes {
  width: 100%;
  height: 100vh;
  background: url(~@/assets/images/bei.png) no-repeat;
  background-size: 100% 100%;
  padding: 110px 0 144px;
  position: relative;
}

.container_c {
  position: absolute;
  top: 349px;
  left: 256px;
  color: #fff;
  font-size: 32px;

  div {
    margin-bottom: 16px;
    font-size: 56px;
    font-weight: bold;
  }
}

.footer {
  position: absolute;
  width: 100%;
  bottom: 46px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  cursor: pointer;

  .links {
    margin-bottom: 8px;
    font-size: 14px;

    a {
      color: rgba(0, 0, 0, 0.45);
      transition: all 0.3s;

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }

  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>
